/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Deployment, Deployment$inboundSchema } from "./deployment.js";

export type GetLatestDeploymentResult = {
  deployment?: Deployment | undefined;
};

/** @internal */
export const GetLatestDeploymentResult$inboundSchema: z.ZodMiniType<
  GetLatestDeploymentResult,
  unknown
> = z.object({
  deployment: z.optional(Deployment$inboundSchema),
});

export function getLatestDeploymentResultFromJSON(
  jsonString: string,
): SafeParseResult<GetLatestDeploymentResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetLatestDeploymentResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetLatestDeploymentResult' from JSON`,
  );
}
